import { ACTIONS } from "../../common/constants";

const productListDataReducer = function (state = null, action) {
  switch (action.type) {
    case ACTIONS.SET_PRODUCT_LIST_DATA:
      return action.data;
    default:
      return state;
  }
};

export default productListDataReducer;
